<template>
  <div class="upload-button">
    <div
      class="upload-wrapper"
      :class="{ avatar: isAvatar, disabled: disabled }"
      :style="`width: ${width}; height: ${height}; min-width: ${minWidth}; min-height: ${minHeight};`"
    >
      <div v-if="!image && !defaultImg" class="plus text-center" :style="`min-width: ${minWidth}; min-height: ${minHeight};`">
        <i class="el-icon-plus " />
      </div>
      <img v-if="!image && defaultImg" :src="defaultImg">

      <label :data-cy="cyUploadBtn" :title="$t('common.dialog.uploadButton.title')" class="input-label" :class="{disabled}">
        <input
          ref="fileInput"
          :disabled="disabled"
          type="file"
          :accept="acceptString"
          @change="imgInput"
        >
      </label>
      <img v-if="image" :data-cy="cyUploadedImg" :src="image" :class="{disabled}">
    </div>
  </div>
</template>

<script>
import { imgLoad, imgSrc, subscriptionImgSrc } from '@/utils/helper'
import { map, join } from 'lodash'
export default {
  name: 'UploadButton',
  // props: ['img', 'isAvatar', 'width', 'height', 'disabled', 'cyUploadBtn', 'cyUploadedImg', 'defaultImg'],
  props: {
    type: { type: String, default: 'default' },
    img: { type: Object, default: null },
    isAvatar: { type: Boolean, default: false },
    width: { type: String, default: '' },
    height: { type: String, default: '' },
    minWidth: { type: String, default: '' },
    minHeight: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    cyUploadBtn: { type: String, default: '' },
    cyUploadedImg: { type: String, default: '' },
    defaultImg: { type: Image, default: null },
    accept: { type: Array, default: () => ['jpg', 'jpeg', 'png'] },
  },
  computed: {
    image () {
      let image = ''
      // if(this.img === null) image = require("@/assets/icon/upload-placeholder.png")
      if (this.img === null) image = null
      // else image = `https://bob-image.flightgoai-service.com/display/resize/80x/${this.img.filename}`
      else image = this.type === 'default' ? imgSrc(300, this.img) : subscriptionImgSrc(this.img)

      return image
    },
    acceptString () {
      return join(map(this.accept, (item) => `.${item}`), ',')
    },
  },

  mounted () {},
  methods: {
    imgInput (e) {
      this.$emit('change', imgLoad(e))
      this.$refs.fileInput.type = 'text'
      this.$refs.fileInput.type = 'file'
      this.$emit('action')
    },
  },
}
</script>

<style scoped lang="scss">
.upload-wrapper {
  position: relative;
  border: dashed 2px #ededed;
  height: 100%;
  border-radius: 4px;
}

.plus {
  font-size: 2rem;
  width: 100%;
  height: 100%;
  display: grid;
  place-content: center;
  @apply bg-gray-40;
}

.avatar {
  width: 90px;
  height: 90px;
  @apply flex justify-center items-center;
  // display: grid;
  // place-content: center;
}

.input-label {
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

input {
  display: none;
}

img {
  @apply w-full h-full object-cover;
  border-radius: 4px;
  // width: 150px;
  // margin: auto;
}

.disabled {
  opacity: 0.5;
  @apply cursor-not-allowed;
}
</style>
